import type { FaireProductEntity } from "../../entity_types/product";

export const toysmith_17: FaireProductEntity = {
  token: "toysmith-17",
  type: "product",
  name: "Mini Bowling, Finger Sized Bowing Set",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/1b6cac351a793c35766f251ea909eb9766b88f7285b9499e21b7638e48cc3f6c.jpeg?bg-color=FFFFFF&canvas=720:720&dpr=1&fit=bounds&format=jpg&height=720&width=720",
  priceDollars: 9.5,
  msrpDollars: 19,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
